/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { FormContext } from "./FormContext";

export const useFormContext = () => React.useContext(FormContext);
export { FormContextProvider } from "./FormContext";
